module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_7.918775ef.png";